import { createSlice } from "@reduxjs/toolkit";
import { requestPassword, resetPassword } from "../../thunks/authThunk";
import { message } from "antd";

const initialState = {
  isLoading: false,
  requestStatus: null, 
  requestResponse: null,
  resetStatus: null, 
  resetResponse: null,
  error: null,
};

export const passwordSlice = createSlice({
  name: "password",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // requestPassword
    builder
      .addCase(requestPassword.pending, (state) => {
        state.isLoading = true;
        state.requestStatus = "loading";
        state.error = null;
      })
      .addCase(requestPassword.fulfilled, (state, action) => {
        state.isLoading = false;
        state.requestStatus = "success";
        state.requestResponse = action.payload;
        if (action.payload?.status == 1) {
          message.success(
            "A password reset link has been sent your Registered email",
            5
          );
        } else {
          message.error("Register email is not found in database", 5);
        }
      })
      .addCase(requestPassword.rejected, (state, action) => {
        state.isLoading = false;
        state.requestStatus = "failed";
        state.error = action.payload;
        message.error("Something went wrong!");
      });

    // resetPassword
    builder
      .addCase(resetPassword.pending, (state) => {
        state.isLoading = true;
        state.resetStatus = "loading";
        state.error = null;
      })
      .addCase(resetPassword.fulfilled, (state, action) => {
        state.isLoading = false;
        state.resetStatus = "success";
        state.resetResponse = action.payload;
        message.success(action.payload.message);
      })
      .addCase(resetPassword.rejected, (state, action) => {
        state.isLoading = false;
        state.resetStatus = "failed";
        message.error("Something went wrong!");
      });
  },
});

export default passwordSlice.reducer;
